<!--
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2020-02-06 13:49:56
 * @LastEditors  : Please set LastEditors
 * @LastEditTime : 2020-02-12 14:44:50
 -->
<template>
  <div class="epidemic-page">
    <Tab
      v-if="tabList.length"
      :tabList="tabList"
      @toggleTab="toggleTab"
      @getSchoolTabList="getSchoolTabList"
    ></Tab>
    <div class="school-tab-wrapper" v-if="showSchoolTab">
      <div
        class="school-tab"
        :class="{ active: schoolTabId === item.id }"
        v-for="item in schoolTabList"
        :key="item.id"
        @click="toggleSchoolTab(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="newscontent">
      <div>
        <ul>
          <li
            v-for="item in articleList.list"
            :key="item.id"
            @click="handleGoContent(item.id, item.live_url)"
          >
            <span class="item-title">{{ item.title }}</span>
            <span class="item-createtime">{{ item.createtime }}</span>
          </li>
        </ul>
      </div>
      <div class="search-footer">
        <el-pagination
          background
          layout="pager, next"
          :current-page="articleList.start_page"
          :total="articleList.count"
          @current-change="currentPageClick"
        ></el-pagination>
      </div>
    </div>
  </div>
</template> 

<script>
import Tab from "@/components/tab";
import http from "@/api/commonApi";

export default {
  props: ['specialPage'],
  components: {
    Tab
  },
  data() {
    return {
      tabList: [],
      tabId: "",
      schoolTabList: [],
      schoolTabId: "",
      articleList: {
        count: null,
        list: [],
        start_page: null,
        total_page: null
      }
    };
  },
  mounted() {
    this.getEpidemicControl(this.pathTwo);
  },
  methods: {
    getEpidemicControl(id) {
      http.getEpidemicControl(id).then(res => {
        this.tabList = res.data;
        this.tabId = this.tabList[0].id;
        this.getList(this.tabId);
      });
    },
    getSchoolTabList(id) {
      console.log(222,this.specialPage)
      if (this.specialPage == 'epidemic') {
        this.tabId = id;
        http.getEpidemicControl(id).then(res => {
          this.schoolTabList = res.data;
          this.schoolTabId = this.schoolTabList[0].id;
          this.getList(this.schoolTabId);
        });
      } else {
        this.getList(id);
      }

    },
    toggleTab(id) {
      this.tabId = id;
      this.getList(this.tabId);
    },
    toggleSchoolTab(id) {
      this.schoolTabId = id;
      this.getList(this.schoolTabId);
    },
    getList(type, start_page = 1) {
      http.getRightList(type, start_page).then(res => {
        const { count, list, start_page, total_page } = res.data;
        this.articleList.count = count;
        this.articleList.list = list;
        this.articleList.start_page = parseInt(start_page);
        this.articleList.total_page = total_page;
      });
    },
    // 点击页数跳转
    currentPageClick(page) {
      let type = this.showSchoolTab ? this.schoolTabId : this.tabId;
      this.getList(type, page);
      this.backTop();
    },
    // 点击右边文章列表进入文章
    handleGoContent(id, url) {
      if (url) {
        window.open(url);
      } else {
        let { href } = this.$router.resolve({
          path: `/${this.pathOne}/${this.pathTwo}/${id}`
        });
        window.open(href, "_blank");
      }
    }, // 点击页数 返回顶部
    backTop() {
      document.documentElement.scrollTop = 0;
    }
  },
  computed: {
    pathOne() {
      return this.$route.path.split("/")[1];
    },
    pathTwo() {
      return this.$route.path.split("/")[2];
    },
    showSchoolTab() {
      if (!this.tabId) return false;
      if (this.specialPage != 'epidemic') {
        return false;
      }
      console.log(this.tabList.filter(v => v.id === this.tabId)[0]);
      return this.tabList.filter(v => v.id === this.tabId)[0].name ===
        "各校动态"
        ? true
        : false;
    }
  }
};
</script>

<style lang="scss">
%mgto {
  margin: 0 auto;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.box-border {
  box-sizing: border-box;
}
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

.epidemic-page {
  width: 934px;
  min-height: 780px;
  background: #ffffff;
  margin-left: 17px;
  margin-bottom: 40px;
  padding: 30px 40px 0 40px;
  box-sizing: border-box;
  @extend .box-border;
  .school-tab-wrapper {
    display: flex;
    .school-tab {
      cursor: pointer;
      box-sizing: border-box;
      margin: 20px 20px 10px 0;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: rgba(243, 243, 243, 1);
      border-radius: 4px;
      @include font-style(PingFang SC, 16px, #3a3a3a, 500);
    }
    .active {
      background-color: #c52e0f;
      color: #fff;
    }
  }
  .newscontent {
    width: 100%;
    height: 100%;
    @include displayflex(space-between, center, column, nowrap);
    @extend .box-border;
    & > div:nth-child(1) {
      width: 100%;
      height: 100%;
      min-height: 570px;
      @include displayflex(flex-start, center, column, nowrap);

      & > ul {
        @extend %ulst;
        width: 100%;
        @include displayflex(flex-start, center, column, nowrap);
        box-sizing: border-box;
        & > li {
          width: 100%;
          line-height: 28px;
          padding-top: 14px;
          padding-bottom: 14px;
          @include displayflex(space-between, center, row, nowrap);
          border-bottom: 1px dashed #dbdbdb;
          cursor: pointer !important;

          .item-title {
            flex: 1;
            @include font-style(PingFangSC-Regular, 17px, #3a3a3a, 400);
            margin-right: 30px;
            &:hover {
              cursor: pointer !important;
              color: #c52e0f !important;
            }
          }
          .item-createtime {
            @include font-style(PingFangSC-Regular, 14px, #7a7a7a, 400);
          }
        }
      }
    }
    & > div:nth-child(2) {
      margin-bottom: 51px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/special_report/epidemic.vue